import type { IUpdateChildLocationsCmd } from "@/data/commands/location/IUpdateChildLocationsCmd";
import { Factory } from "@/data/dao/Factory";
import { type DaoError, type IMultiEntityLinkDataSource } from "@/data/dao/service/BaseServiceDao";
import { LocationDao } from "@/data/dao/service/LocationDao";
import type { ILocationDetail } from "@/data/model/Location";
import { exceptionTypes } from "@/data/util/Config";

import { MultiEntityInput } from "@/components/formControls/MultiEntityInput";

import { i18n } from "@/portal/Trans";
import { BaseEntityForm } from "@/portal/forms/BaseEntityForm";

export class ChildLocationsForm extends BaseEntityForm<ILocationDetail, IUpdateChildLocationsCmd> {
    private dao: LocationDao;

    private childLocationsInput: MultiEntityInput;
    private locationId?: string;

    constructor(element: JQuery) {
        super(element, {
            getSingle: undefined as any,
            create: undefined as any,
            getData: undefined as any,
            remove: undefined as any,
            update: (i, d) => Factory.getInstance<LocationDao>(LocationDao).setChildLocations(i, d),
        });

        this.dao = Factory.getInstance<LocationDao>(LocationDao);

        const childLocationDataSource: IMultiEntityLinkDataSource = {
            search: (e, t) => {
                return this.dao.searchChildLocations(this.locationId!, e, t);
            },
        };

        this.childLocationsInput = MultiEntityInput.createFromInput(
            this.$form.find('.form-control[name="child-locations"]'),
            {
                dataSource: childLocationDataSource,
            }
        );
    }

    getFormData($form: JQuery): IUpdateChildLocationsCmd | undefined {
        const childLocationIds = this.childLocationsInput.getValue();
        return { childLocationIds: childLocationIds };
    }

    protected resolveErrorMessage(e, b: DaoError): string | undefined {
        if (b?.additionalData?.reason == null) {
            return undefined;
        }

        switch (b.additionalData.reason) {
            case exceptionTypes.linkedLocationCircularRelationException:
                return i18n("location.childLocations.linkedLocationCircularRelationError");
            case exceptionTypes.internalNameOfAllChildLocationsMustBeUniqueException:
                return i18n("location.childLocations.internalNameOfAllChildLocationsMustBeUniqueError");
        }
        return b.additionalData.reason;
    }

    protected setFormData(model: ILocationDetail | undefined) {
        this.locationId = model?.id;

        this.childLocationsInput.setValue(
            model === undefined
                ? undefined
                : model.childLocations
                      .sort((a, b) => {
                          return a.createdDateTime > b.createdDateTime ? 1 : -1;
                      })
                      .map((c) => {
                          return {
                              id: c.childLocationId,
                              name: c.childLocationInternalName ?? c.childLocationName ?? "",
                          };
                      })
        );
    }
}
